import { FC } from 'react';
import Interview from 'types/Interview';
import { Container } from './components';

type Props = {
  interview: Interview | undefined;
};
const Late: FC<Props> = ({ interview }) => {
  return (
    <Container>
      <p>
        {interview?.menteeLate
          ? "Le mentoré ne s'est pas présenté à l'heure du rendez-vous."
          : interview?.mentorLate
          ? "Le mentor ne s'est pas présenté à l'heure du rendez-vous."
          : "Au moins un participant ne s'est pas présenté à l'heure du rendez-vous."}
      </p>
    </Container>
  );
};

export default Late;
